export const toCapitalize = str => str.charAt(0).toUpperCase() + str.slice(1)
